import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    try {
      const consent = localStorage.getItem("neilai_cookie_consent");
      if (!consent) {
        setShowBanner(true);
      }
    } catch (e) {
      console.error("Error reading cookie consent:", e);
    }
  }, []);

  const handleAccept = () => {
    try {
      localStorage.setItem("neilai_cookie_consent", "accepted");
      setShowBanner(false);
    } catch (e) {
      console.error("Error saving cookie consent:", e);
    }
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[9999] bg-background border-t border-border shadow-[0_-4px_20px_rgba(0,0,0,0.45)] p-4">
      <div className="container mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="text-sm text-foreground max-w-2xl">
          We use cookies and similar technologies to improve your experience, analyze traffic and personalize content.
          By clicking <strong>Accept</strong>, you agree to our use of cookies as described in our Privacy Policy.
        </div>
        <div className="flex gap-2 shrink-0">
          <Button onClick={handleAccept} className="bg-green-600 hover:bg-green-700">
            Accept
          </Button>
          <Button variant="outline" asChild>
            <Link to="/privacy">Privacy Policy</Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
